var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.98877H8.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.9849V1.98486H7C8.06087 1.98486 9.07828 2.40629 9.82843 3.15644C10.5786 3.90658 11 4.924 11 5.98486C11 7.04573 10.5786 8.06315 9.82843 8.81329C9.07828 9.56344 8.06087 9.98486 7 9.98486C8.06087 9.98486 9.07828 10.4063 9.82843 11.1564C10.5786 11.9066 11 12.924 11 13.9849C11 15.0457 10.5786 16.0631 9.82843 16.8133C9.07828 17.5634 8.06087 17.9849 7 17.9849H1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 11.318H24.9998C24.9998 10.0804 24.5082 8.89337 23.633 8.0182C22.7578 7.14303 21.5708 6.65137 20.3332 6.65137C19.0955 6.65137 17.9085 7.14303 17.0333 8.0182C16.1582 8.89337 15.6665 10.0804 15.6665 11.318V13.9847C15.804 14.9829 16.261 15.9098 16.969 16.6268C17.677 17.3438 18.5981 17.8123 19.5945 17.9624C20.5909 18.1124 21.6092 17.936 22.497 17.4593C23.3847 16.9827 24.0944 16.2315 24.5198 15.318",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.98486H22.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.7bc45a99046f0a8ee5d4e7b3ae1183e1.svg";
export { ForwardRef as ReactComponent };